import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

let ffmpeg: FFmpeg | null = null;

export const loadFFmpeg = async () => {
  if (ffmpeg) {
    console.log('FFmpeg already loaded, returning existing instance');
    return ffmpeg;
  }

  console.log('Loading FFmpeg...');
  ffmpeg = new FFmpeg();
  
  try {
    console.log('Loading FFmpeg core files...');
    const coreURL = await toBlobURL('/ffmpeg-core.js', 'text/javascript');
    const wasmURL = await toBlobURL('/ffmpeg-core.wasm', 'application/wasm');
    
    console.log('FFmpeg core URLs:', { coreURL, wasmURL });
    
    await ffmpeg.load({
      coreURL,
      wasmURL,
    });
    
    console.log('FFmpeg loaded successfully');
    return ffmpeg;
  } catch (error) {
    console.error('Error loading FFmpeg:', error);
    console.error('FFmpeg load error details:', {
      code: (error as any)?.code,
      message: (error as any)?.message,
      name: (error as any)?.name,
      stack: (error as any)?.stack
    });
    throw error;
  }
};

export const createAudioPreview = async (file: File): Promise<File> => {
  console.log('Creating audio preview for file:', {
    name: file.name,
    size: file.size,
    type: file.type
  });
  
  const ffmpeg = await loadFFmpeg();
  const fileExtension = file.name.slice(file.name.lastIndexOf('.'));
  const fileName = file.name.substring(0, file.name.lastIndexOf('.'));

  try {
    console.log('Writing file to FFmpeg virtual filesystem...');
    // Write the file to FFmpeg's virtual filesystem
    await ffmpeg.writeFile('input' + fileExtension, await fetchFile(file));
    console.log('File written to FFmpeg filesystem successfully');

    console.log('Executing FFmpeg command to create preview...');
    // Run FFmpeg command to create 30-second preview
    await ffmpeg.exec([
      '-i', 'input' + fileExtension,
      '-t', '30',
      '-c:a', 'libmp3lame',
      '-b:a', '128k',
      'preview.mp3'
    ]);
    console.log('FFmpeg command executed successfully');

    console.log('Reading preview file from FFmpeg filesystem...');
    // Read the preview file
    const previewData = await ffmpeg.readFile('preview.mp3');
    console.log('Preview file read successfully, size:', previewData.length);
    
    const previewBlob = new Blob([previewData], { type: 'audio/mp3' });
    const previewFile = new File([previewBlob], `${fileName}_preview.mp3`, { type: 'audio/mp3' });
    
    console.log('Preview file created:', {
      name: previewFile.name,
      size: previewFile.size,
      type: previewFile.type
    });
    
    return previewFile;
  } catch (error) {
    console.error('Error creating preview:', error);
    console.error('Preview creation error details:', {
      code: (error as any)?.code,
      message: (error as any)?.message,
      name: (error as any)?.name,
      stack: (error as any)?.stack
    });
    throw error;
  }
}; 